<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="title"><a id="page1"></a><a id="page2"></a><em>one light still shines</em></h1>
<p class="center"><span class="big">My Life Beyond <em>the</em> Shadow <em>of the</em></span><br/> <span class="big">Amish Schoolhouse Shooting</span><br/><br/><br/><br/><br/></p>
<p class="center"><span class="bigtp">Marie Monville</span> <em>with</em> Cindy Lambert<br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?1ad10d4b